import React from 'react';

import './App.css';
import BaminMainTemplate from './Component/BaminMain/BaminMainTemplate';

function App() {
  return (
    <BaminMainTemplate/>
  );
}

export default App;
